import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var MileageIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M1.75 14C1.75 8.34 6.34 3.75 12 3.75S22.25 8.34 22.25 14a.75.75 0 0 0 1.5 0c0-6.49-5.26-11.75-11.75-11.75S.25 7.51.25 14a.75.75 0 0 0 1.5 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M13 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM4 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17.5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM21 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12 20.5a2.5 2.5 0 1 0-.579-4.933L8.96 11.136a.75.75 0 0 0-1.312.728l2.485 4.473A2.5 2.5 0 0 0 12 20.5Zm1-2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
                clipRule: "evenodd"
            })
        ]
    }));
};
